import { useState } from 'react';
import {checkStyleConditions} from '../Funtions'

import './svg_s.css'

import { ReactSVG } from "react-svg";

function StyleModal({useFilter, sel, setSel}) {

    const [on, setOn] = useState(1);

    return ( 
    <div className="presets_style">
        <div className='hori_center' style={{width:"100%", textAlign:"center"}}><h3>Select Styles</h3></div>
        <br/>
        <div className="stylemodal_wrapper hori_center">   
            
        <div className='s-filter-wrapper'>
                    {useFilter && useFilter.map((value, key) => (
                        <>
                            {sel && sel.types && sel.types.includes(value.name) && (
                                <div className={`s-filter-body button3-50'} ${checkStyleConditions(sel, value, null) ? 'opacity_03' : ''}`}
                                    // style={null && value.type ==="Lapel" ? {opacity:"0.5"}:{}}
                                    id={`style_type_${value.place}`}
                                >
                                    {/* <label
                                        style={{"padding":"3px 8px", "background":"#14213D", "color":"white","width":"fit-content", "fontSize":"0.7rem", "marginBottom":"0", "borderRadius":"5px"}}
                                    >Coat </label> */}
                                    { value["place"] && <div
                                        style={{"opacity":"1", "padding":"3px 8px", "background":"#14213D", "color":"white", "marginBottom":"10px", "borderRadius":"5px", "textAlign":"center"}}
                                    >{value["place"]} </div>}
                                    
                                    <br/>
                                    {!Object.hasOwn(value, "hdr") && <div className='txt-font'>  <b>{value.type}</b> </div>}
                                    {Object.hasOwn(value, "sub") && <div className='txt-font1'> {value.sub} </div> }
                                    <div className={`s-filter-type button-50'}`}>
                                        {value.attr.map((val, k) => (
                                            <div className={`s-filter-row button2-50'}`} key={k}>
                                                {val.map((val1, k1) => (
                                                    <div
                                                        type = {(!checkStyleConditions(sel, value, null, val1)) ? 'button':""} 
                                                        className={(!checkStyleConditions(sel, value, null, val1) && sel.style?.[value.name]?.[value.pos]?.[value.n] === val1.value) ? 's-f-card-h' 
                                                            : checkStyleConditions(sel, value, null, val1) ? 'dis_hov s-f-card' 
                                                            : 's-f-card'}
                                                        onClick={async () => {
                                                            if (on === 1) {
                                                                if ( checkStyleConditions(sel, value, null, val1)
                                                                    || sel.style?.[value.name]?.[value.pos]?.[value.n] === val1.value) {
                                                                    console.log("Selecting same thing again");
                                                                } else {

                                                                    
                                                                    

                                                                    let arr = sel["style"][value["name"]][value["pos"]]
                                                                    arr[value["n"]] = val1["value"]

                                                                    
                                                                    

                                                                    let obj = {...sel}
                                                                    obj["style"][value["name"]][value["pos"]] = arr
                                                                    
                                                                    if( (obj && obj.style && obj.style.Pant && obj.style.Pant.F[1] === "R") &&
                                                                        (obj.style.Pant.F[0] === "F-DP" || obj.style.Pant.F[0] === "F-SP")
                                                                    ){
                                                                        obj.style.Pant.F[1] = "C"
                                                                    }
                                                                    
                                                                    if( (obj && obj.style && obj.style.Pant && obj.style.Pant.F[2] === "H") &&
                                                                        (obj.style.Pant.F[0] === "F-DP")
                                                                    ){
                                                                        obj.style.Pant.F[2] = "L"
                                                                    }
                                                                    
                                                                    console.log("from Style :", obj)
                                                                    setSel(obj)
                                                                    
                                                                }
                                                            }
                                                        }}
                                                        key={k1}
                                                    >
                                                        {/* <img src={val1.img} className='s-f-img' /><br /> */}
                                                        {/* {val1.img} */}
                                                        {/* <svg className='s-f-img'>
                                                        
                                                        {val1.img}
                                                        </svg><br /> */}
                                                        <ReactSVG src={val1.img} className={`s-f-img ${(sel.style?.[value.name]?.[value.pos]?.[value.n] === val1.value && !( checkStyleConditions(sel, value, null, val1)  ) ) ? `filter_svg` : ''} `}
                                                        />
                                                        <div className={sel.style?.[value.name]?.[value.pos]?.[value.n] === val1.value && !( checkStyleConditions(sel, value, null, val1) )? 'sel_style_txt' : 'not_sel_txt'}>
                                                            {val1.name}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </>
                    ))}
                </div>

        </div>
    </div> );
}

export default StyleModal;